var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgShieldCheck(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("g", { clipPath: "url(#shield-check_svg__clip0_3501_2627)" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.613 6.226c-4.381-1.169-7.41-2.65-8.614-3.294-1.204.645-4.232 2.125-8.613 3.294.11 3.956.981 7.09 2.434 9.543 1.461 2.467 3.548 4.312 6.18 5.625 2.63-1.313 4.716-3.157 6.177-5.622 1.454-2.455 2.325-5.588 2.436-9.546zm-9.36-5.45a1.518 1.518 0 011.493 0c.753.423 3.996 2.152 8.994 3.418.662.168 1.14.77 1.134 1.469-.041 4.536-.99 8.267-2.761 11.255-1.775 2.996-4.334 5.176-7.473 6.667a1.495 1.495 0 01-1.281 0c-3.14-1.491-5.7-3.672-7.475-6.67-1.77-2.99-2.72-6.723-2.759-11.261-.006-.739.52-1.304 1.143-1.462C10.26 2.925 13.5 1.2 14.253.775zm-2.568 10.366a1.125 1.125 0 10-1.595 1.588l2.638 2.649a1.5 1.5 0 002.121.005l5.03-5.007a1.125 1.125 0 10-1.588-1.594l-4.498 4.477-2.108-2.117z", fill: "#000" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "shield-check_svg__clip0_3501_2627" },
                React.createElement("path", { fill: "#fff", transform: "translate(0 .143)", d: "M0 0h30v24H0z" })))));
}
var ForwardRef = React.forwardRef(SvgShieldCheck);
export default ForwardRef;
